const wrapElement = document.querySelector('.wrap');
const contpcElement = document.querySelector('.contpc');
const targetElement0 = document.querySelector('.mainback');
const targetElement1 = document.querySelector('.collection01b');
const targetElement2 = document.querySelector('.collection03');
const targetElement3 = document.querySelector('.collection04');
const targetElement4 = document.querySelector('.pannierback');
const txt02Elements = document.querySelectorAll('.txt02');
const priceElements = document.querySelectorAll('.price');
const toggleLines = document.querySelectorAll('.toggle-button .line');
const creditElements = document.querySelectorAll('.credit');

let currentBgClass = '';
let currentTextColor = '';
let currentBgColor = '';
let isFading = false;

function setInitialState() {
  contpcElement.classList.remove(
    'bg-collection01',
    'bg-pannier',
    'bg-collection03',
    'bg-collection04'
  );
  // 初期画像はCSSで指定されているもの（mainback）
  contpcElement.style.opacity = '1';
  wrapElement.style.backgroundColor = '#3a0909';
  [...txt02Elements, ...priceElements, ...creditElements].forEach(
    el => (el.style.color = '#fff')
  );
  toggleLines.forEach(el => (el.style.backgroundColor = '#fff'));
  currentBgClass = 'initial';
  currentBgColor = '#3a0909';
  currentTextColor = '#fff';
}

function updateBackground() {
  const triggerPoint = window.innerHeight * 0.7;

  const rects = [
    targetElement0.getBoundingClientRect(),
    targetElement1.getBoundingClientRect(),
    targetElement2.getBoundingClientRect(),
    targetElement3.getBoundingClientRect(),
    targetElement4.getBoundingClientRect(),
  ];

  let newBgClass = '';
  let bgColor = '#fff';
  let textColor = '#000';

  // === 「右側のスクロールコンテンツが一番上」に来たら初期画像にする ===
  if (window.scrollY < 10 || rects[0].top >= 0) {
    newBgClass = 'initial';
    bgColor = '#3a0909';
    textColor = '#fff';
  } else if (rects[1].top <= triggerPoint && rects[1].bottom > triggerPoint) {
    newBgClass = 'bg-collection01';
    bgColor = '#472b1f';
    textColor = '#fff';
  } else if (rects[2].top <= triggerPoint && rects[2].bottom > triggerPoint) {
    newBgClass = 'bg-collection03';
    bgColor = '#ead8d8';
    textColor = '#000';
  } else if (rects[3].top <= triggerPoint && rects[3].bottom > triggerPoint) {
    newBgClass = 'bg-collection04';
    bgColor = '#cecdd9';
    textColor = '#000';
  } else if (rects[4].top <= triggerPoint && rects[4].bottom > triggerPoint) {
    newBgClass = 'bg-pannier';
    bgColor = '#907777';
    textColor = '#fff';
  } else {
    newBgClass = 'initial';
    bgColor = '#3a0909';
    textColor = '#fff';
  }

  // === 背景フェード処理（ちらつき防止付き） ===
  if (newBgClass !== currentBgClass && !isFading) {
    isFading = true;
    contpcElement.style.transition = 'opacity 0.5s ease';
    contpcElement.style.opacity = '0.5';

    setTimeout(() => {
      // 先に新しいクラスを追加（空白状態を防ぐ）
      if (newBgClass && newBgClass !== 'initial') {
        contpcElement.classList.add(newBgClass);
      }

      // 少し遅らせて前のクラスを削除
      setTimeout(() => {
        contpcElement.classList.remove(
          'bg-collection01',
          'bg-pannier',
          'bg-collection03',
          'bg-collection04'
        );

        // 「初期状態」ならクラスを全て削除したままにする
        if (newBgClass && newBgClass !== 'initial') {
          contpcElement.classList.add(newBgClass);
        }

        currentBgClass = newBgClass;
        contpcElement.style.opacity = '1';
        setTimeout(() => (isFading = false), 600);
      }, 50);
    }, 100);
  }

  // === wrapの背景色フェード ===
  if (bgColor !== currentBgColor) {
    wrapElement.style.transition = 'background-color 0.8s ease';
    wrapElement.style.backgroundColor = bgColor;
    currentBgColor = bgColor;
  }

  // === テキスト色変更 ===
  if (textColor !== currentTextColor) {
    [...txt02Elements, ...priceElements, ...creditElements].forEach(
      el => (el.style.color = textColor)
    );
    toggleLines.forEach(el => (el.style.backgroundColor = textColor));
    currentTextColor = textColor;
  }
}

// イベント登録
window.addEventListener('scroll', updateBackground);
window.addEventListener('load', () => {
  setInitialState();
  updateBackground();
});
//      back sp     //


//      header     //
(function() {
  const fh = document.getElementById('fixed-header');
  window.addEventListener('scroll', () => {
    if (window.pageYOffset > 100) {
      fh.classList.add('is-show');
    } else {
      fh.classList.remove('is-show');
    }
  });
}());

//      POPUP     //
function toggleMask(button) {
    const mask = button.parentElement.querySelector('.mask');
    const caption = button.parentElement.querySelector('.caption');
    mask.classList.toggle('fade-in'); // フェードイン用クラスの切り替え
    caption.classList.toggle('fade-in'); // キャプションのフェードインも切り替え
    button.classList.toggle('show-button');
}
